import React, { useEffect, useState } from 'react';
import { apiService } from '../services/api';
import { useApi, useMutation } from '../hooks/useApi';
import logger from '../utils/logger';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { useSettings } from '../context/SettingsContext';
import { PlusCircle, Pencil, Trash2, Wallet, ArrowLeft, ArrowRight } from 'lucide-react';
import Select from 'react-select';


function Harxhimet() {
  const { roli, lokacion_id } = useAuth();
  const { theme } = useTheme();
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [llojiId, setLlojiId] = useState('');
  const [shuma, setShuma] = useState('');
  const [editId, setEditId] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [llojiFilter, setLlojiFilter] = useState('');
  const perFaqe = 10;
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [lokacionFilter, setLokacionFilter] = useState('');
  const [lokacionInput, setLokacionInput] = useState('');

  // Helper function to safely format dates
  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '—';
    return date.toLocaleDateString();
  };

  const getParams = () => {
    const params = {};
    if (roli === 'admin' && lokacionFilter) {
      params.lokacion_id = lokacionFilter;
    }
    if (roli !== 'admin') {
      params.lokacion_id = lokacion_id;
    }
    return params;
  };

  const { data: llojetData, execute: refetchLlojet } = useApi(
    () => apiService.get('/lloj-harxhimi'),
    [],
    { immediate: true, showNotifications: false }
  );

  const { data: harxhimetData, execute: refetchHarxhimet } = useApi(
    () => apiService.get('/harxhimet', { params: getParams() }),
    [roli, lokacion_id, lokacionFilter],
    { immediate: true, showNotifications: false }
  );

  const { data: lokacionetData } = useApi(
    () => apiService.get('/lokacionet'),
    [],
    { immediate: roli === 'admin', showNotifications: false }
  );

  const llojet = Array.isArray(llojetData) ? llojetData : (llojetData?.data || []);
  const harxhimet = Array.isArray(harxhimetData) ? harxhimetData : (harxhimetData?.data || []);
  const lokacionet = Array.isArray(lokacionetData) ? lokacionetData : (lokacionetData?.data || []);

  useEffect(() => {
    refetchHarxhimet();
  }, [lokacionFilter, refetchHarxhimet]);

  const harxhimeTeFiltruara = harxhimet.filter(h => {
    if (!h.created_at) return false; // Skip items without date
    const dateObj = new Date(h.created_at);
    if (isNaN(dateObj.getTime())) return false; // Skip invalid dates
    const data = dateObj.toISOString().slice(0, 10);
    const pasFrom = !fromDate || data >= fromDate;
    const paraTo = !toDate || data <= toDate;
    const llojiMatch = !llojiFilter || h.lloji_id == llojiFilter;
    const lokacionMatch = !lokacionFilter || h.lokacion_id == lokacionFilter;
    return pasFrom && paraTo && llojiMatch && lokacionMatch;
  });

  const totalGjithsej = harxhimeTeFiltruara.reduce((acc, h) => acc + parseFloat(h.shuma || 0), 0);

  const faqetTotale = Math.ceil(harxhimeTeFiltruara.length / perFaqe);
  const harxhimeFaqes = harxhimeTeFiltruara.slice((currentPage - 1) * perFaqe, currentPage * perFaqe);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    const data = {
      lloji_id: llojiId,
      shuma: parseFloat(shuma),
      data: new Date().toISOString().slice(0, 10),
      ...(roli === 'admin' ? { lokacion_id: lokacionInput || null } : { lokacion_id })
    };

    if (editId) {
      updateHarxhim({ id: editId, data });
    } else {
      createHarxhim(data);
    }
  };

 const handleEdit = (h) => {
  setEditId(h.id);
  setLlojiId(h.lloji_id);
  setShuma(h.shuma);
  if (roli === 'admin') {
    setLokacionInput(h.lokacion_id);
  }
};

  const { mutate: createHarxhim } = useMutation(
    async (data) => {
      return await apiService.post('/harxhimet', data);
    },
    {
      successMessage: 'Harxhimi u regjistrua me sukses!',
      onSuccess: () => {
        setLlojiId('');
        setShuma('');
        setLokacionInput('');
        setEditId(null);
        refetchHarxhimet();
      }
    }
  );

  const { mutate: updateHarxhim } = useMutation(
    async ({ id, data }) => {
      return await apiService.put(`/harxhimet/${id}`, data);
    },
    {
      successMessage: 'Harxhimi u përditësua me sukses!',
      onSuccess: () => {
        setLlojiId('');
        setShuma('');
        setLokacionInput('');
        setEditId(null);
        refetchHarxhimet();
      }
    }
  );

  const { mutate: deleteHarxhim } = useMutation(
    async (id) => {
      return await apiService.delete(`/harxhimet/${id}`);
    },
    {
      successMessage: 'Harxhimi u fshi me sukses!',
      onSuccess: () => {
        refetchHarxhimet();
      }
    }
  );

  const handleDelete = async (id) => {
    if (!window.confirm('A jeni i sigurt që doni ta fshini këtë harxhim?')) return;
    deleteHarxhim(id);
  };

  // Custom styles for react-select based on theme
  const selectStyles = theme === 'dark' ? {
    control: (base, state) => ({
      ...base,
      backgroundColor: '#1e293b',
      borderColor: state.isFocused ? '#f59e0b' : '#475569',
      boxShadow: state.isFocused ? '0 0 0 1px #f59e0b' : 'none',
      '&:hover': { borderColor: '#f59e0b' },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: '#1e293b',
      borderColor: '#475569',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#78350f' : state.isSelected ? '#f59e0b' : '#1e293b',
      color: state.isSelected ? 'white' : '#e2e8f0',
    }),
    singleValue: (base) => ({ ...base, color: '#e2e8f0' }),
    input: (base) => ({ ...base, color: '#e2e8f0' }),
    placeholder: (base) => ({ ...base, color: '#94a3b8' }),
  } : {
    control: (base, state) => ({
      ...base,
      backgroundColor: 'transparent',
      borderColor: state.isFocused ? '#f59e0b' : '#d1d5db',
      boxShadow: state.isFocused ? '0 0 0 1px #f59e0b' : 'none',
      '&:hover': { borderColor: '#f59e0b' },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: 'white',
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#fef3c7' : state.isSelected ? '#fbbf24' : 'white',
      color: state.isSelected ? 'white' : '#111827',
    }),
  };

  return (
    <div className="w-full animate-fade-in">
      <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gradient-logo flex items-center gap-3 animate-slide-down">
        <div className="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
          <Wallet size={32} className="text-primary-600 dark:text-primary-400" />
        </div>
        Menaxhimi i Harxhimeve
      </h2>

      {error && (
        <div className="mb-6 p-4 rounded-xl bg-red-50 dark:bg-red-900/20 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800 animate-slide-down">
          <p className="font-medium">{error}</p>
        </div>
      )}
      {success && (
        <div className="mb-6 p-4 rounded-xl bg-green-50 dark:bg-green-900/20 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800 animate-slide-down">
          <p className="font-medium">{success}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="card-premium p-6 mb-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <Select
          options={llojet.map(l => ({ value: l.id, label: l.emri }))}
          value={
            llojiId
              ? { value: llojiId, label: llojet.find(l => l.id === Number(llojiId))?.emri }
              : null
          }
          onChange={(option) => setLlojiId(option?.value || '')}
          placeholder="Zgjidh llojin"
          className="w-full"
          isClearable
          styles={selectStyles}
          classNamePrefix="react-select"
        />

        <input
          type="number"
          value={shuma}
          onChange={(e) => setShuma(e.target.value)}
          placeholder={`Vlera në ${currencyCode}`}
          className="input-premium"
          required
          min="0.01"
          step="0.01"
        />
        {roli === 'admin' && (
          <Select
            options={lokacionet.map(l => ({ value: l.id, label: l.emri }))}
            value={
              lokacionInput
                ? { value: lokacionInput, label: lokacionet.find(l => l.id === Number(lokacionInput))?.emri }
                : null
            }
            onChange={(option) => setLokacionInput(option?.value || '')}
            placeholder="Lokacioni i harxhimit"
            className="w-full"
            isClearable
            styles={selectStyles}
            classNamePrefix="react-select"
          />
        )}

        <button
          type="submit"
          className="btn-primary flex items-center justify-center gap-2 col-span-full md:col-span-1"
        >
          <PlusCircle size={18} />
          {editId ? 'Përditëso' : 'Regjistro'}
        </button>
      </form>

      {/* Filtrat */}
      <div className="card-premium p-6 mb-6 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="form-label">Nga data</label>
            <input
              type="date"
              value={fromDate}
              onChange={(e) => {
                setCurrentPage(1);
                setFromDate(e.target.value);
              }}
              className="input-premium"
            />
          </div>
          <div>
            <label className="form-label">Deri më</label>
            <input
              type="date"
              value={toDate}
              onChange={(e) => {
                setCurrentPage(1);
                setToDate(e.target.value);
              }}
              className="input-premium"
            />
          </div>
        </div>

        <div>
          <label className="form-label">Filtrimi sipas llojit</label>
          <Select
            options={llojet.map(l => ({ value: l.id, label: l.emri }))}
            value={
              llojiFilter
                ? { value: llojiFilter, label: llojet.find(l => l.id === llojiFilter)?.emri }
                : null
            }
            onChange={(option) => {
              setCurrentPage(1);
              setLlojiFilter(option?.value || '');
            }}
            placeholder="Filtro sipas llojit"
            className="w-full"
            isClearable
            styles={selectStyles}
            classNamePrefix="react-select"
          />
        </div>

        {roli === 'admin' && (
          <div>
            <label className="form-label">Filtro sipas lokacionit</label>
            <Select
              options={lokacionet.map(l => ({ value: l.id, label: l.emri }))}
              value={
                lokacionFilter
                  ? { value: lokacionFilter, label: lokacionet.find(l => l.id === lokacionFilter)?.emri }
                  : null
              }
              onChange={(option) => {
                setCurrentPage(1);
                setLokacionFilter(option?.value || '');
              }}
              placeholder="Zgjidh lokacionin"
              className="w-full"
              isClearable
              styles={selectStyles}
              classNamePrefix="react-select"
            />
          </div>
        )}
      </div>

      {/* Total Section */}
      {harxhimeTeFiltruara.length > 0 && (
        <div className="card-premium p-6 mb-6 bg-gradient-to-r from-primary-50 via-secondary-50 to-primary-50 dark:from-primary-900/20 dark:via-secondary-900/20 dark:to-primary-900/20 border-primary-200 dark:border-primary-800">
          <div className="text-center">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">Totali i harxhimeve</p>
            <p className="text-3xl font-bold text-gradient-logo">{totalGjithsej.toFixed(2)} {currencyCode}</p>
          </div>
        </div>
      )}

      {/* Paginimi */}
      {faqetTotale > 1 && (
        <div className="card-premium flex items-center justify-center gap-6 mt-6 flex-wrap px-6 py-4 mb-6">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
            className={`btn-premium-secondary flex items-center gap-2 text-sm ${
              currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            <ArrowLeft size={16} /> Mbrapa
          </button>
          <span className="text-gray-700 dark:text-gray-300 text-sm font-medium">
            Faqja <span className="text-primary-600 dark:text-primary-400 font-semibold">{currentPage}</span> nga{' '}
            <span className="font-semibold">{faqetTotale}</span>
          </span>
          <button
            onClick={() => setCurrentPage((prev) => Math.min(prev + 1, faqetTotale))}
            disabled={currentPage === faqetTotale}
            className={`btn-premium-secondary flex items-center gap-2 text-sm ${
              currentPage === faqetTotale ? 'opacity-50 cursor-not-allowed' : ''
            }`}
          >
            Para <ArrowRight size={16} />
          </button>
        </div>
      )}

      {/* Tabela */}
      <div className="card-premium overflow-x-auto">
        <table className="table-premium">
          <thead>
            <tr>
              <th>#</th>
              <th>Lloji</th>
              <th>Vlera</th>
              <th>Data</th>
              {roli === 'admin' && <th>Lokacioni</th>}
              <th>Veprime</th>
            </tr>
          </thead>
          <tbody>
            {harxhimeFaqes.length === 0 ? (
              <tr>
                <td colSpan={roli === 'admin' ? 6 : 5} className="text-center py-8 text-gray-500 dark:text-gray-400">
                  Nuk ka harxhime të regjistruar
                </td>
              </tr>
            ) : (
              harxhimeFaqes.map((h, i) => (
                <tr key={h.id}>
                  <td>{(currentPage - 1) * perFaqe + i + 1}</td>
                  <td className="font-medium">{h.lloji?.emri}</td>
                  <td>
                    <span className="font-semibold text-primary-600 dark:text-primary-400">{Number(h.shuma).toFixed(2)} {currencyCode}</span>
                  </td>
                  <td>{formatDate(h.created_at)}</td>
                  {roli === 'admin' && (
                    <td>{h.lokacion?.emri || '—'}</td>
                  )}
                  <td>
                    <div className="flex gap-2">
                      <button onClick={() => handleEdit(h)} className="text-secondary-600 dark:text-secondary-400 hover:text-secondary-800 dark:hover:text-secondary-300 inline-flex items-center gap-1 transition-colors">
                        <Pencil size={16} /> Edito
                      </button>
                      <button onClick={() => handleDelete(h.id)} className="text-red-600 dark:text-red-400 hover:text-red-800 dark:hover:text-red-300 inline-flex items-center gap-1 transition-colors">
                        <Trash2 size={16} /> Fshi
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Harxhimet;
